// extracted by mini-css-extract-plugin
export default {"separatedLine":"NoSearchResultsBanner-module__separatedLine___3pkvr"};